import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y } from 'swiper/modules'

const BrandsCarouselSkeleton = () => {
    return (
        <section className="snippet-brands-carousel is-loading" aria-label="Loading brands">
            <div className="snippet-brands-carousel__container">
                <div className="skeleton skeleton-heading"></div>
                <Swiper
                    className="snippet-brands-carousel__swiper"
                    modules={[Navigation, Pagination, A11y]}
                    navigation={false}
                    pagination={false}
                    spaceBetween={12}
                    slidesPerView={1}
                    breakpoints={{
                        479: {
                            slidesPerView: 2,
                        },
                        991: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 4,
                        },
                    }}
                >
                    <SwiperSlide className="skeleton snippet-brands-carousel__slide"></SwiperSlide>
                    <SwiperSlide className="skeleton snippet-brands-carousel__slide"></SwiperSlide>
                    <SwiperSlide className="skeleton snippet-brands-carousel__slide"></SwiperSlide>
                    <SwiperSlide className="skeleton snippet-brands-carousel__slide"></SwiperSlide>
                </Swiper>
            </div>
        </section>
    )
}

export default BrandsCarouselSkeleton
